
import { Observable, throwError } from "rxjs"
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Shared } from '../models/shared';

@Injectable({
    providedIn: 'root'
})
export class HttpClientWrapper {
    BaseUrl: string = Shared.baseUrl;
    TransmitterApiBaseUrl: string = Shared.TransmitterApiBaseUrl;

    constructor(private http: HttpClient) {
    }

    GetAsync<T>(url: string): Observable<T> {
        return this.http.get<T>(url).pipe(
            catchError((error: HttpErrorResponse) => {
                return this.ThrowError(error);
            })
        );
    }

    PutAsync<T>(url: string, body: any): Observable<T> {
        return this.http.put<T>(url, body).pipe(
            catchError((error: HttpErrorResponse) => {
                return this.ThrowError(error);
            })
        );
    }

    PostAsync<T>(url: string, body: any): Observable<T> {
        return this.http.post<T>(url, body).pipe(
            catchError((error: HttpErrorResponse) => {
                return this.ThrowError(error);
            })
        );
    }

    DeleteAsync<T>(url: string): Observable<T> {
        return this.http.delete<T>(url).pipe(
            catchError((error: HttpErrorResponse) => {
                return this.ThrowError(error);
            })
        );
    }

    PostSync<T>(url: string, body: any, addAuthenticationToken: boolean=false): T {
        var xmlHttpRequest = new XMLHttpRequest();
        xmlHttpRequest.open("POST", url, false); // false for synchronous request

        // if (addAuthenticationToken == true) {
        //     let token = this.localStorageService.GetItem(LoginTypeKeys.userAccesssToken);

        //     if (token === undefined || token == null || token.trim() == '') {
        //         this.router.navigateByUrl("/account/signin");
        //         return;
        //     }

        //     xmlHttpRequest.setRequestHeader("Authorization", "Bearer " + token);
        // }

        xmlHttpRequest.send(body);
        let response: T = JSON.parse(xmlHttpRequest.response);
        return response;
    }

    GetSync<T>(url: string, addAuthenticationToken: boolean= false): T {
        var xmlHttpRequest = new XMLHttpRequest();
        xmlHttpRequest.open("GET", url, false); // false for synchronous request

        // if (addAuthenticationToken == true) {
        //     let token = this.localStorageService.GetItem(LoginTypeKeys.userAccesssToken);

        //     if (token === undefined || token == null || token.trim() == '') {
        //         this.router.navigateByUrl("/account/signin");
        //         return;
        //     }

        //     xmlHttpRequest.setRequestHeader("Authorization", "Bearer " + token);
        // }

        xmlHttpRequest.send(null);
        let response: T = JSON.parse(xmlHttpRequest.response);
        return response;
    }

    ThrowError(errorResponse: HttpErrorResponse) {
        return throwError(errorResponse);
    }
}